import { render } from "./vagentdividedetailed.vue?vue&type=template&id=22dcde4b&scoped=true"
import script from "./vagentdividedetailed.vue?vue&type=script&lang=js"
export * from "./vagentdividedetailed.vue?vue&type=script&lang=js"

import "./vagentdividedetailed.vue?vue&type=style&index=0&id=22dcde4b&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22dcde4b"]])

export default __exports__